import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sass-two-services',
  templateUrl: './sass-two-services.component.html',
  styleUrls: ['./sass-two-services.component.scss']
})
export class SassTwoServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
